<template>
  <div class="">
    <el-header style="padding: 0px;display:flex;justify-content:flex-end;align-items: center">
      <select-text v-model="filterParams.cityCode" code-set-id="" :options="cityOptions" placeholder="所在城市" style="width: 120px;margin-right: 10px;"/>
      <select-text v-model="filterParams.cusId" code-set-id="" :options="cusOptions"  placeholder="所属公司" style="width: 120px;margin-right: 10px;"/>
      <select-text v-model="filterParams.orderStatus" code-set-id="1005" placeholder="订单状态" style="width: 120px;margin-right: 10px;"/>
      <select-text v-model="filterParams.isHighSeas" code-set-id="1006" placeholder="是否公海" style="width: 120px;margin-right: 10px;"/>
      <span style="font-size: 14px;">用车日期：</span>
      <el-date-picker
        v-model="filterParams.period"
        type="daterange"
        align="right"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyy-MM-dd"
        style="width: 200px;">
      </el-date-picker>
      <el-popover trigger="manual"  v-model="showAdvanceSearchView" placement="bottom" height="300" width="450" ref="popover1">
        <el-row>
          <el-col :span="12">订单编号：<el-input v-model="filterParams.orderNum" placeholder="输入订单编号" style="width:150px;" clearable=""></el-input></el-col>
          <el-col :span="12">下单人：<el-input v-model="filterParams.empName" placeholder="输入下单人" style="width:150px;" clearable=""/></el-col>
        </el-row>
        <el-row>
          <el-col :span="12"><span>启用状态：</span><select-text v-model="filterParams.status" code-set-id="0" placeholder="启用状态" style="width: 120px;margin-right: 10px;margin-top: 10px;"/></el-col>
        </el-row>
        <el-button slot="reference" type="text" style="margin: 0px 10px 0px 5px;" @click="onMore">{{showAdvanceSearchView==false?'更多':'收起'}}<i :class="showAdvanceSearchView==false?'el-icon-arrow-down':'el-icon-arrow-up'"></i></el-button>
      </el-popover>
      <el-button v-waves class="filter-item" type="primary" size="mini" icon="el-icon-search" @click="searchProduct()">搜索</el-button>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          @click="exportTable">
          导出
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="success"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="batchUpdate('1')">
          启用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          :disabled="operDisabled"
          type="danger"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="batchUpdate('0')">
          禁用
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="handleAdd">
          下单
        </el-button>
      </div>
      <div style="margin-left: 10px;display: inline">
        <el-button
          type="primary"
          size="mini"
          v-if="loginInfo.userType=='1'"
          @click="handleCalc">
          费用结算
        </el-button>
      </div>
    </el-header>
    <iTable
      :data="dataList"
      :col-configs="colConfigs"
      :default-sort="{prop: 'age', order: 'descending'}"
      :row-class-name="tableRowClassName"
      :row-click="clickRowEvent"
      :max-height="maxHeight"
      :select="selectCheck"
      :show-loading="isLoading"
      :table-key="tableKey"
      :selection-change="handleSelectionChange"
      :filter-change="handleFilterChange"
      :sort-change="handleSortChange"
      itable-loading="loading"
      row-key="id"
    >
      <el-table-column slot="selection" align="center" type="selection" width="50" fixed="left"/>
      <!--<el-table-column slot="index" :formatter="formatterIndex" label="序号" align="center" width="50" fixed="left"/>-->
      <el-table-column slot="operate" label="操作" width="250" fixed="right" align="left">
        <template slot-scope="scope">
<!--          <el-button type="text" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
          <!--<el-button type="text" v-if="scope.row.approvalStatus=='10020001'" size="small" @click.stop="toDetail(scope.$index, scope.row)">审核</el-button>-->
          <template v-if="loginInfo.userType!='5'||(loginInfo.userType=='5'&&scope.row.isHighSeas=='10060002')">
            <template v-if="(scope.row.dispatchStatus==null||scope.row.dispatchStatus=='')&&scope.row.parentId=='-1'">
              <el-button type="text"  size="small" @click.stop="handleDispatch(scope.$index, scope.row)">手动派单</el-button>
            </template>
            <template v-else-if="scope.row.orderStatus=='10050001'||scope.row.orderStatus=='10050002'||scope.row.orderStatus=='10050003'">
              <el-button type="text"  size="small" @click.stop="handleDispatch(scope.$index, scope.row)">手动派单</el-button>
            </template>
          </template>
          <el-button type="text" size="small" @click.stop="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button type="text"  size="small" @click.stop="toDetail(scope.$index, scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </iTable>
    <el-pagination
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :total="page.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"/>
    <!--弹出内容-->
    <add v-if="showAddVisible" ref="add" @refresh="initData"/>
    <dispatch v-if="showDispatchVisible" ref="dispatch" @refresh="initData"/>
  </div>
</template>
<script>
  /* eslint-disable handle-callback-err */
  import waves from '@/directive/waves' // Waves directive
  import iTable from '@/components/table/index'
  import add from './edit'
  import SelectText from '@/components/SelectText/index.vue'
  import { getListpage,batchUpdateStatus,exportOrder,batchCalcAmount } from  "@/api/order/orderinfo"
  import { loadCusList } from  "@/api/cus/cusinfo"
  import { downloadExcelFile, getCurrentMonthFirst,getCurrentMonthLast} from  "@/util/util"
  import { citys } from '@/const/city.js'
  import dispatch from "./dispatch";
  import {mapGetters} from "vuex";
  export default {
    components: {dispatch, iTable, add,SelectText },
    directives: { waves },
    data() {
      return {
        showAdvanceSearchView:false,
        showAddVisible: false,
        showAddAdminVisible: false,
        showDispatchVisible: false,
        operDisabled: true,
        selection: [], // 选中的数据
        maxHeight: null,
        clientHeight: null,
        dataList: [],
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 10
        },
        isLoading: false,
        dialogVisible: false,
        showFooter: false, // 是否显示弹框的底部按钮
        fixFooter: true, // 是否固定显示组件内的footer按钮
        beginDateScope: '',
        faangledoubleup: 'fa-angle-double-up',
        faangledoubledown: 'fa-angle-double-down',
        filterParams: {
          status:'',
          driverName:'',
          orderStatus: '',
          isHighSeas:'',
          cusId:'',
          cityCode:'',
          period: '',
          orderNum:'',
          empName:''
        },
        tableKey: 'table1', // 区分唯一性  solt渲染时需要对应的key
        cityOptions:citys,
        cusOptions:[],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      };
    },
    computed: {
      // 注意！！！colConfigs不能放在data 里面，因为当语言切换的时候 他是不会变的 ，要写在computed内
      colConfigs() {
        return [
          { slot: 'selection' }, // 复选框列
          /*{ slot: 'index' }, // 序号列*/
          { prop: 'orderStatusTxt', label: '订单状态', align: 'center',width: '100'},
          { prop: 'approvalStatusTxt', label: '订单审批状态', align: 'center',width: '120'},
          { prop: 'isHighSeasTxt', label: '是否公海', align: 'center',width: '100'},
          { prop: 'confirmAddress', label: '实际收车位置', align: 'center'},
          { prop: 'confirmDistanceTips', label: '收车位置提示', align: 'center'},
          { prop: 'orderNum', label: '订单编号', align: 'center',width: '200'},
          { prop: 'carRentalTime', label: '下单时间', align: 'center',width: '150' },
          { prop: 'departureTime', label: '起始时间', align: 'center',width: '150' },
          { prop: 'startPointName', label: '起始地点', align: 'center',width: '150' },
          { prop: 'startMileage', label: '起始里程', align: 'center' },
          { prop: 'endTime', label: '结束时间', align: 'center',width: '150'},
          { prop: 'endPointName', label: '结束地点', align: 'center',width: '150' },
          { prop: 'endMileage', label: '结束里程', align: 'center' },
          { prop: 'cusName', label: '企业名称', align: 'center',width: '150' },
          { prop: 'deptName', label: '项目名称', align: 'center' },
          { prop: 'cityName', label: '城市', align: 'center' },
          { prop: 'cusAdminName', label: '管理员', align: 'center' },
          { prop: 'empName', label: '用车人', align: 'center'},
          { prop: 'rideConfirmerName', label: '实际用车人', align: 'center'},
          { prop: 'empPhone', label: '联系电话', align: 'center'},
          { prop: 'driverCompany', label: '所属车队', align: 'center'},
          { prop: 'orderDriverName', label: '司机', align: 'center' },
          { prop: 'orderDriverPhone', label: '联系电话', align: 'center' },
          { prop: 'vehicleBrand', label: '车辆类型', align: 'center'},
          { prop: 'plateNumber', label: '车牌号', align: 'center'},
          { prop: 'carRentalLongTxt', label: '用车类型', align: 'center'},
          { prop: 'carNumber', label: '使用数量', align: 'center' },
          { prop: 'useCarTime', label: '用车时长(分钟)', align: 'center' },
          { prop: 'timeOut', label: '超时时间(分钟)', align: 'center' },
          { prop: 'mileage', label: '使用里程', align: 'center' },
          { prop: 'personNumber', label: '乘车人数(人)', align: 'center' },
          { prop: 'carTime', label: '用车时间', align: 'center',width: '150' },
          { prop: 'orderTypeTxt', label: '租车类型', align: 'center' },
          { prop: 'dispatchStatusTxt', label: '派单方式', align: 'center' },
          { prop: 'statusTxt', label: '启用状态', align: 'center'},
          { prop: 'putUpFee', label: '住宿费', align: 'center' },
          { prop: 'parkingFee', label: '停车费', align: 'center' },
          { prop: 'highSpeedFee', label: '高速费', align: 'center' },
          { prop: 'carAmountTotal', label: '车辆费用合计', align: 'center' },
          { prop: 'timeoutAmountTotal', label: '超时费', align: 'center' },
          { prop: 'oilAmountTotal', label: '油费合计', align: 'center' },
          { prop: 'amountTotal', label: '合计总费用', align: 'center' },
          { prop: 'taxCosts', label: '税费', align: 'center' },
          { prop: 'serviceCosts', label: '服务费', align: 'center' },
          { prop: 'allAmountTotal', label: '应收款合计', align: 'center' },
          { prop: 'expensesSettledTxt', label: '订单结算状态', align: 'center',width: '120'},
          /*{ prop: 'rideConfirmerName', label: '乘车确认人', align: 'center' },
          { prop: 'rideConfirmTime', label: '乘车确认时间', align: 'center' },
          { prop: 'confirmTime', label: '订单确认时间', align: 'center',width: '150' },
          { prop: 'confirmTypeTxt', label: '订单确认类型', align: 'center' },*/
          { slot: 'operate' } // 操作
        ]
      },
      ...mapGetters(["isFullScren", "isCollapse", "userInfo", "loginInfo","menu", "opened","memberInfo"])
    },
    watch: {
      // 如果 `clientHeight` 发生改变，这个函数就会运行
      clientHeight: function() {
        this.changeFixed(this.clientHeight)
      }
    },
    mounted() {
      /**
       * type:1 未处理订单  2 今日进行中  3 今日已接单  4 今日已取消  5 本月累计订单
       */
      let type = this.$route.query.type
      let date=new Date();
      let year=date.getFullYear();
      let month=date.getMonth()+1;
      let day=date.getDate();
      if(month<10){
        month='0'+month
      }
      if(day<10){
        day='0'+day
      }
      let currentDate = year+'-'+month+'-'+day
      if(type=='1'){
        this.$set(this.filterParams,'status','1')
        this.$set(this.filterParams,'orderStatus','10050001')
      }else if(type=='2'){
        this.$set(this.filterParams,'status','1')
        this.$set(this.filterParams,'orderStatus','10050003')
        this.$set(this.filterParams,'period',[currentDate,currentDate])
      }else if(type=='3'){
        this.$set(this.filterParams,'status','1')
        this.$set(this.filterParams,'orderStatus','10050002')
        this.$set(this.filterParams,'period',[currentDate,currentDate])
      }else if(type=='4'){
        this.$set(this.filterParams,'status','1')
        this.$set(this.filterParams,'orderStatus','10050005')
        this.$set(this.filterParams,'period',[currentDate,currentDate])
      }else if(type=='5'){
        //this.$set(this.filterParams,'orderStatus','10050005')
        this.$set(this.filterParams,'status','1')
        this.$set(this.filterParams,'period',[getCurrentMonthFirst(),getCurrentMonthLast()])
      }
      //从缓存获取数据
      if(type==''){
        let filterParams = localStorage.getItem("orderFilter");
        if(filterParams){
          this.filterParams = JSON.parse(filterParams);
        }
      }
      this.initData();
      this.loadCusList();
    },
    methods: {
      initData() {
        const that = this
        // 获取浏览器可视区域高度
        that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        window.onresize = function temp() {
          that.$set(that, 'clientHeight', `${document.documentElement.clientHeight}`)
        }
        if(this.filterParams.period){
          let startDate = this.filterParams.period[0]
          let endDate = this.filterParams.period[1]
          this.$set(this.filterParams,'startDate',startDate)
          this.$set(this.filterParams,'endDate',endDate)
        }else{
          this.$set(this.filterParams,'startDate','')
          this.$set(this.filterParams,'endDate','')
        }
        that.loadProduct()
      },
      loadCusList(){
        loadCusList().then(res => {
          this.cusOptions = res.data.data
        })
      },
      searchProduct() {
        this.page.currentPage = 1
        if(this.filterParams.period){
          let startDate = this.filterParams.period[0]
          let endDate = this.filterParams.period[1]
          this.$set(this.filterParams,'startDate',startDate)
          this.$set(this.filterParams,'endDate',endDate)
        }else{
          this.$set(this.filterParams,'startDate','')
          this.$set(this.filterParams,'endDate','')
        }
        this.loadProduct()
      },
      // 给行加行号
      tableRowClassName({ row, rowIndex }) {
        // 把每一行的索引放进row
        row.index = rowIndex
      },
      formatterIndex(row, column, cellValue, index) {
        // 放回索引值
        return this.page.currentPages * (this.page.pageSize - 1) + 1 + row.index
      },
      // 点击行事件
      clickRowEvent(row, column, event) {
        console.log(row)
        console.log(column)
        console.log(event)
      },
      // 选中复选框事件
      selectCheck(selection, row) {
        // 你可以这样修改行数据值
        // selection[0].id = '123'
        console.log(selection)
        console.log(row)
      },
      handleSelectionChange(val) {
        this.selection = val
        if (val.length > 0) {
          this.operDisabled = false
        } else {
          this.operDisabled = true
        }
      },
      // 批量发布/禁用
      batchUpdate: function(status) {
        const val = this.selection
        let ids = ''
        for (let i = 0; i < val.length; i++) {
          if (val[i].status !== status) {
            ids += val[i].id + ','
          }
        }
        if (ids) {
          ids = ids.substring(0, ids.lastIndexOf(','))
          const that = this
          let title = '确定要禁用选中订单吗？'
          let title1 = '禁用成功'
          if (status === '1') {
            title = '确定要启用选中订单吗？'
            title1 = '启用成功'
          }
          this.$confirm(title, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            batchUpdateStatus({ id: ids, status: status }).then((res) => {
                that.$message.success(title1)
                that.loadProduct()
            })
          })
        } else {
          let title1 = '请选择已启用的订单'
          if (status === '1') {
            title1 = '请选择未启用的订单'
          }
          this.$message.info(title1);
        }
      },
      //费用结算
      handleCalc(){
        const val = this.selection;
        let ids = '';
        for (let i = 0; i < val.length; i++) {
          if (val[i].orderStatus == '10050004') {
              ids += val[i].id + ','
          }
        }
        if (ids) {
          ids = ids.substring(0, ids.lastIndexOf(','))
          const that = this
          this.$confirm('确定要结算费用吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            batchCalcAmount({ id: ids }).then((res) => {
              that.$message.success('结算成功！')
              that.loadProduct()
            })
          })
        } else {
          this.$message.info('请选择已结束的订单');
        }
      },
      // 表格最大高自适应
      changeFixed(clientHeight) {
        // 导航栏高65+边距上下30*2+ el-table 链接高40 + 分页高32 = 183
        this.$set(this, 'maxHeight', clientHeight - 197)
      },
      // 页码变化时
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        // 切换成每页20条的数据
        this.page.pageSize = val
        this.isLoading=true
        this.loadProduct()
      },
      // 当前页变化时
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        // 获取table数据
        this.page.currentPage = val
        this.isLoading=true
        this.loadProduct()
      },
      loadProduct() {
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        getListpage(params).then(res => {
          this.page.total = res.data.total
          this.dataList = res.data.records
          this.isLoading = false
        })
      },
      // 当talbel中任何一列的过滤条件点击确定和覆盖时，都会触发此事件。
      handleFilterChange(filters) {
        // 拷贝filters的值。
        for (const i in filters) {
          const row = i // 保存 column-key的值，如果事先没有为column-key赋值，系统会自动生成一个唯一且恒定的名称
          const val = filters[i]
          if (val != null && val.length > 0) {
            this.$set(this.filterParams, row, val[0])
          } else {
            this.$set(this.filterParams, row, '')
          }
        }
        this.currentPage = 1
        this.loadProduct()
      },
      // 新增
      handleAdd() {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init('')
        })
      },
      // 编辑
      handleEdit(index, row) {
        this.showAddVisible = true
        this.$nextTick(() => {
          this.$refs.add.init(row.id)
        })
      },
      // 详情
      toDetail(index, row) {
        //缓存搜索条件
        localStorage.setItem("orderFilter",JSON.stringify(this.filterParams));
        this.$router.push({
          path: '/order/detail',
          query: {
            id: row.id,
            userType:'1'
          }
        })
      },
      //派单
      handleDispatch(index, row) {
        this.showDispatchVisible = true
        this.$nextTick(() => {
          this.$refs.dispatch.init(row.id)
        })
      },
      //导出表格
      exportTable() {
        //exportMethod({columns: this.$refs['accountTable'].tableColums, ...this.listQuery}, '/cus');
        //window.open(process.env.VUE_APP_BASE_API + '/emp/exportEmp', '_parent');
        if(this.filterParams.period){
          let startDate = this.filterParams.period[0]
          let endDate = this.filterParams.period[1]
          this.$set(this.filterParams,'startDate',startDate)
          this.$set(this.filterParams,'endDate',endDate)
        }else{
          this.$set(this.filterParams,'startDate','')
          this.$set(this.filterParams,'endDate','')
        }
        exportOrder(this.filterParams).then(res => {
          downloadExcelFile(res,this);
        }).catch(resp => {
          this.$notify.error(resp.msg || '导出失败')
        })
      },
      onMore(){
        this.showAdvanceSearchView=!this.showAdvanceSearchView
        if(!this.showAdvanceSearchView){
          this.$set(this.filterParams,'orderNum','')
          this.$set(this.filterParams,'empName','')
        }
      }
    }
  }
</script>
<style scoped>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-input--mini .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
</style>
